import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
// Constants
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
// Services
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
// NgRx
import { setViewRootFolder } from 'FoldersApp/state/view-root-folder/view-root-folder.action';
import { setName } from 'FoldersApp/state/name/name.action';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i2 from "@ngrx/store";
/**
 * Directive to set the view root folder when clicking on the decorated element.
 * - Assumes there is an instance of NgRx store injected in the root of the application; and that this store includes
 *   a `folderId` slice.
 *
 * Usage:
 *  <div id='folder-1' ycn-set-view-root-folder [folderId]="id"></div>
 */
export class SetViewRootFolderDirective {
    constructor(folderableAppConfig, folderableCollectionService, store) {
        this.folderableAppConfig = folderableAppConfig;
        this.folderableCollectionService = folderableCollectionService;
        this.store = store;
    }
    setViewRootFolder() {
        // When text search is active, results are displayed as a flat list.
        // To allow clicking into folders, clear the name filter to get nested results.
        if (this.folderableCollectionService.textSearchActive) {
            this.store.dispatch(setName({ name: '' }));
        }
        switch (this.folderableAppConfig.folderableAppType) {
            case FolderableAppType.MODAL:
                this.refreshData();
                break;
            case FolderableAppType.LIST_PAGE:
                this.updateState();
                break;
            default:
        }
    }
    refreshData() {
        const params = {
            ...cloneDeep(this.folderableCollectionService.dataParams),
            viewRootFolder: this.folderId,
            name: '',
        };
        this.folderableCollectionService.refreshData(params);
    }
    updateState() {
        this.store.dispatch(setViewRootFolder({ id: this.folderId }));
    }
}
SetViewRootFolderDirective.ɵfac = function SetViewRootFolderDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SetViewRootFolderDirective)(i0.ɵɵdirectiveInject(FOLDERABLE_APP_CONFIG), i0.ɵɵdirectiveInject(i1.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i2.Store)); };
SetViewRootFolderDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: SetViewRootFolderDirective, selectors: [["", "ycn-set-view-root-folder", ""]], hostBindings: function SetViewRootFolderDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function SetViewRootFolderDirective_click_HostBindingHandler() { return ctx.setViewRootFolder(); });
    } }, inputs: { folderId: "folderId" }, standalone: false });
